

















































import {defineComponent, onBeforeMount, reactive} from '@vue/composition-api'
import firebase from '@/horizon-firebase'
import {userStore} from '@/store'

export default defineComponent({
  name: 'EmailActionVerification',
  props: {},
  setup(props, context) {
    const user = firebase.auth().currentUser
    const action = context.root.$route.query.mode || false
    const code = context.root.$route.query.oobCode || false
    const isEmailVerification = action && action === 'verifyEmail'
    const isPasswordReset = action && action === 'resetPassword'
    const isEmailRecovery = action && action === 'recoverEmail'

    const state = reactive({
      userName: user ? user.displayName : 'anonymous',
      action,
      verificationInProgress: true,
      codeVerified: false,
      errorMessage: '',
    })

    onBeforeMount(async () => {
      console.log('EmailActionVerification.onBeforeMount()', {action, code})
      if (action && code) {
        state.verificationInProgress = true
        if (isEmailVerification) {
          try {
            await firebase.auth().applyActionCode(`${code}`)
            state.codeVerified = true
            state.errorMessage = ''
            await userStore.reloadUser()
            // TODO: Here would be a good place to call a GCF func to
            // set up the user again, since we have a valid email now.
            // E.g. give them .edu discount, anything else we need to
            // do on the back end.
          } catch (e) {
            state.codeVerified = false
            state.errorMessage = e.message
            console.log('Could not verify email verification code', e)
          }
        } else if (isPasswordReset) {
          // TODO: Password reset
          /*
          try {
            await firebase.auth().verifyPasswordResetCode(code)
            state.codeVerified = true
          } catch (e) {
            state.codeVerified = false
            console.log('Could not verify password reset code', e)
          }
          */
        } else if (isEmailRecovery) {
          // TODO: Email recovery
        } else {
          // Unknown action
          console.warn(`EmailActionVerification: unknown action "${action}"`)
        }
        state.verificationInProgress = false
      } else {
        console.warn(`EmailActionVerification: missing action "${action}" or code "${code}"`)
      }
    })

    return {state, isEmailVerification, isPasswordReset}
  }
})
